"use client"

import styled from "@emotion/styled"
import { CustomBreadcrumbs } from "ui"
import Container from "ui/Container"

type Props = {
  breadCrumbs: any
  children: React.ReactNode
}

const StyledDiv = styled.div`
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
  padding-top: 16px;
  padding-bottom: 64px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 32px;
  }
`

const StyledContentWrapper = styled.div`
  padding-top: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 32px;
  }
  h3 {
    padding-top: 14px;
    ${({ theme }) => theme.breakpoints.up("md")} {
      padding-top: 28px;
    }
  }
`

const TermsLayout = ({ breadCrumbs, children }: Props) => {
  return (
    <Container paddingMobile>
      <StyledDiv>
        <CustomBreadcrumbs breadcrumbs={breadCrumbs} />
        <StyledContentWrapper>{children}</StyledContentWrapper>
      </StyledDiv>
    </Container>
  )
}

export default TermsLayout
